import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'
import Text from './Text'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: 8,
    flexGrow: 1,
  },
  line: {
    marginBottom: 8,
  },
  text: {
    fontSize: 12,
  },
  title: {
    color: colors.strongGray,
    fontSize: 12,
    fontFamily: 'Inter-Bold',
  },
})

const ConsentText = ({ title, text }) => (
  <View wrap={false}>
    <View style={[styles.container, { marginTop: 20 }]}>
      <Text style={[{ color: colors.strongGray }, styles.text]}>
        <Text style={styles.title}>{title}</Text>
        {text}
      </Text>
    </View>
  </View>
)

ConsentText.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default ConsentText
